import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { login } from '../../actions/index';
import { Notifications } from '../common/notification';
import { RC_LOAD_APP } from '../routers/RouteConstants';
import { saveUser, getUser, logoutUser } from '../../actions/session';
import { isNonEmptyDict } from '../../actions/validator';
import { clientInfo } from '../..';
import Axios from 'axios';
import { USER_LOGIN_REDIRECT } from '../../config/rest_endpoints';

class Login extends Component {
  constructor(props) {
    super(props);
    let checkToken = null;
    this.state = {
      userDetails: { username: '', password: '' },
      isLoad: false,
      isLoader: false,
      clientID: clientInfo,
      User: getUser(),
      adminLoginData: {},
      tokenRemove: checkToken
    };

    this.chkUser = this.chkUser.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.handleValue = this.handleValue.bind(this);
  }

  componentWillMount() {
    const { clientID, tokenRemove } = this.state;
    console.log('tokenRemove :>> ', tokenRemove);
    console.log('clientID :>> ', clientID);
    if (clientID.includes('token')) {
      console.log('22 :>> ', 22);
      this.accessByAdminId();
    }
  }

  accessByAdminId() {
    const { User, clientID } = this.state;
    const payload = {
      accountID: clientID[1]
    };
    this.setState({ isRedirectLoader: true });
    const headers = { Authorization: 'Bearer ' + clientID[3] };
    Axios.post(USER_LOGIN_REDIRECT, payload, { headers })
      .then((res) => {
        if (res) {
          const resp = res.data.data;
          const token = res.headers['x_auth_token'] || clientID[3];
          // Clear token from clientInfo so logout doesn't auto-login again
          const tokenIdx = clientInfo.indexOf('token');
          if (tokenIdx !== -1) {
            clientInfo.splice(tokenIdx, clientInfo.length - tokenIdx);
          }
          this.props.login(resp, token);
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`accessByAdminId error:`, err);
        this.setState({ isRedirectLoader: false });
        if (alert?.data?.message === 'invalid or expired jwt') {
          logoutUser();
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, 'Token Expire', 'error');
        } else if (alert?.data?.message) {
          Notifications.notify(alert.data.message, 'Failed', 'error');
        } else {
          Notifications.notify('Unable to login via admin portal', 'Error', 'error');
        }
      });
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({ isLoad: true });
    }, 2000);
    this.chkUser();
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  componentWillReceiveProps(newProps) {
    let { activeUser } = newProps;
    if (isNonEmptyDict(activeUser)) {
      saveUser(activeUser);
      this.props.history.push(RC_LOAD_APP);
      Notifications.notify('Login Successfully', 'Login', 'success');
    }
  }

  chkUser() {
    let current_user = getUser();
    if (current_user) {
      this.props.history.push(RC_LOAD_APP);
      this.setState({ isLoad: false });
    }
  }

  handleValue(e) {
    let { name, value } = e.target;
    let { userDetails } = this.state;
    userDetails[name] = value;
    this.setState({ userDetails });
  }

  clearForm() {
    let userDetails = { username: '', password: '' };
    this.setState({ userDetails });
  }

  onLogin() {
    this.setState({ isLoader: true });
    let { userDetails } = this.state;
    this.props.login(userDetails);
    let current_user = getUser();
    if (!current_user) {
      setTimeout(() => {
        this.setState({ isLoader: false });
      }, 1000);
    }
  }

  render() {
    const { userDetails } = this.state;
    let { username, password } = userDetails;

    var loading = (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '100vh'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '3px solid rgba(255, 255, 255, 0.1)',
          borderTopColor: '#6366F1',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }}></div>
      </div>
    );

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background decorative elements */}
        <div style={{
          position: 'absolute',
          top: '-20%',
          right: '-10%',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(99, 102, 241, 0.08) 0%, transparent 70%)',
          pointerEvents: 'none'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '-15%',
          left: '-5%',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.06) 0%, transparent 70%)',
          pointerEvents: 'none'
        }}></div>

        {this.state.isLoad ? (
          <div style={{
            width: '100%',
            maxWidth: '420px',
            animation: 'fadeInUp 0.5s ease forwards'
          }}>
            {/* Logo area */}
            <div style={{
              textAlign: 'center',
              marginBottom: '32px'
            }}>
              <div style={{
                width: '52px',
                height: '52px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '16px',
                boxShadow: '0 8px 24px rgba(99, 102, 241, 0.3)'
              }}>
                <i className="fa fa-bolt" style={{ color: '#fff', fontSize: '22px' }}></i>
              </div>
              <h2 style={{
                color: '#F8FAFC',
                fontSize: '24px',
                fontWeight: '700',
                letterSpacing: '-0.03em',
                margin: '0 0 4px'
              }}>
                Outbound <span style={{ color: '#6366F1' }}>Switch</span>
              </h2>
              <p style={{
                color: '#64748B',
                fontSize: '14px',
                margin: 0
              }}>Customer Portal</p>
            </div>

            {/* Login card */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.03)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '20px',
              padding: '36px',
              backdropFilter: 'blur(20px)',
              WebkitBackdropFilter: 'blur(20px)'
            }}>
              <div style={{ marginBottom: '24px' }}>
                <h3 style={{
                  color: '#F1F5F9',
                  fontSize: '18px',
                  fontWeight: '600',
                  margin: '0 0 4px',
                  letterSpacing: '-0.01em'
                }}>Welcome back</h3>
                <p style={{
                  color: '#64748B',
                  fontSize: '13px',
                  margin: 0
                }}>Enter your credentials to continue</p>
              </div>

              <form onSubmit={(e) => { e.preventDefault(); this.onLogin(); }}>
                {/* Username field */}
                <div style={{ marginBottom: '16px' }}>
                  <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#94A3B8',
                    marginBottom: '6px',
                    letterSpacing: '0.02em'
                  }}>Username</label>
                  <div style={{ position: 'relative' }}>
                    <div style={{
                      position: 'absolute',
                      left: '14px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#475569',
                      fontSize: '14px',
                      pointerEvents: 'none'
                    }}>
                      <i className="fas fa-user"></i>
                    </div>
                    <input
                      type="text"
                      name="username"
                      value={username}
                      onChange={this.handleValue}
                      placeholder="Enter your username"
                      autoComplete="username"
                      style={{
                        width: '100%',
                        padding: '12px 14px 12px 40px',
                        background: 'rgba(255, 255, 255, 0.05)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '12px',
                        color: '#F1F5F9',
                        fontSize: '14px',
                        outline: 'none',
                        transition: 'all 200ms ease',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = 'rgba(99, 102, 241, 0.5)';
                        e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>

                {/* Password field */}
                <div style={{ marginBottom: '24px' }}>
                  <label style={{
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: '500',
                    color: '#94A3B8',
                    marginBottom: '6px',
                    letterSpacing: '0.02em'
                  }}>Password</label>
                  <div style={{ position: 'relative' }}>
                    <div style={{
                      position: 'absolute',
                      left: '14px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#475569',
                      fontSize: '14px',
                      pointerEvents: 'none'
                    }}>
                      <i className="fas fa-lock"></i>
                    </div>
                    <input
                      type="password"
                      name="password"
                      value={password}
                      onChange={this.handleValue}
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      style={{
                        width: '100%',
                        padding: '12px 14px 12px 40px',
                        background: 'rgba(255, 255, 255, 0.05)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        borderRadius: '12px',
                        color: '#F1F5F9',
                        fontSize: '14px',
                        outline: 'none',
                        transition: 'all 200ms ease',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = 'rgba(99, 102, 241, 0.5)';
                        e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>

                {/* Sign in button */}
                <button
                  type="submit"
                  disabled={this.state.isLoader}
                  style={{
                    width: '100%',
                    padding: '12px',
                    background: this.state.isLoader ? 'rgba(99, 102, 241, 0.5)' : 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: '600',
                    cursor: this.state.isLoader ? 'not-allowed' : 'pointer',
                    transition: 'all 200ms ease',
                    boxShadow: this.state.isLoader ? 'none' : '0 4px 14px rgba(99, 102, 241, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    letterSpacing: '-0.01em'
                  }}
                  onMouseEnter={(e) => {
                    if (!this.state.isLoader) {
                      e.target.style.transform = 'translateY(-1px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(99, 102, 241, 0.4)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 14px rgba(99, 102, 241, 0.3)';
                  }}
                >
                  {this.state.isLoader ? (
                    <>
                      <span style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid rgba(255,255,255,0.3)',
                        borderTopColor: '#fff',
                        borderRadius: '50%',
                        display: 'inline-block',
                        animation: 'spin 0.8s linear infinite'
                      }}></span>
                      Signing in...
                    </>
                  ) : (
                    <>
                      Sign In
                      <i className="icon-circle-right2" style={{ fontSize: '14px' }}></i>
                    </>
                  )}
                </button>
              </form>
            </div>

            {/* Footer text */}
            <p style={{
              textAlign: 'center',
              color: '#475569',
              fontSize: '12px',
              marginTop: '24px'
            }}>
              Secured by Outbound Switch
            </p>
          </div>
        ) : loading}
      </div>
    );
  }
}

function mapStateToProps({ activeUser }) {
  return { activeUser };
}

export default connect(mapStateToProps, { login })(withRouter(Login));
